<template>
  <div>
    <vue-element-loading :active="submiting" />
    <v-card color="grey lighten-1" class="mb-12" elevation="0">
      <v-card-text>
        <div class="row">
          <div class="col-md-4">
            <div
              class="list-group-item pa-2"
              :class="selectedIdx == index ? 'active-stop' : ''"
              v-for="(element, index) in stops"
              :key="element.order"
              @click="
                selectedItem = element.place_id;
                selectedIdx = index;
              "
            >
              <div class="font-weight-bold text-dark m-1 my-1">
                {{ element.name }}
              </div>
              <div class="text-dark m-1 my-1">
                {{ element.address }}
              </div>
              <div class="font-weight-bold text-dark m-1 my-4">
                <div v-if="index!==0">
                  <div v-for="(direction, j) in directions[index-1]" :key="direction.index">
                    <div v-if="direction.current === 1">
                      Direction: {{ direction.summary }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-space-between m-1 my-1 align-center">
                <div>
                  <span class="font-weight-light mr-2"> Stop</span>
                  <v-badge :content="index + 1" inline> </v-badge>
                  <div class="d-flex align-center mt-2">
                    <span class="font-weight-bold mr-2"> Arrival time</span>
                    <v-dialog
                      v-if="mode!=3 && index>0"
                      v-model="timeModals[index]"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="time[index]"
                          outlined
                          dense
                          label="Arrival time"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click="openTimePicker(index)"
                          class="mx-2"
                          style="max-width: 120px;"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="timeModals[index]"
                        v-model="tempTime[index]"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="cancelTimeChange(index)">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="saveTimeChange(index)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                    <span v-else class="mx-2">{{time[index]}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8" id="map">
            <GoogleMapLoader
              :enabled="false"
              :center="center"
              :selected="selectedItem"
              :zoom="zoom"
              :apiKey="apiKey"
              :markers="markers"
              :polylines="polyline"
            >
            </GoogleMapLoader>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-btn v-if="mode!=3" color="primary" @click="finish"> Finish </v-btn>
    <v-btn v-if="mode!=3" text @click="back"> Back </v-btn>
  </div>
</template>
<script>
import GoogleMapLoader from "../../../components/GoogleMapLoader.vue";

import VueElementLoading from "vue-element-loading";

export default {
  components: {
    GoogleMapLoader,
    VueElementLoading,
  },
  props: {
    trip: Object,
    timestep: Number,
    mode: Number,
    apiKey: String,
    originLat: Number,
    originLng: Number,
  },
  data() {
    return {
      time:[],
      timeModals: [], // Array to track time picker modals
      originalTime: [], // Array to store original time values for cancel functionality
      tempTime: [], // Temporary time value for the picker
      route_id: null,
      markers: [],
      selectedIdx: null,
      currentPlace: null,
      stops: [],
      directions: [],
      polyline:[],
      colors: [
        "#000000",
        "#FF0000",
        "#0000FF",
        "#FF00FF",
        "#808080",
        "#800000",
        "#008000",
        "#800080",
        "#008080",
        "#000080",
      ],
      center: null,
      zoom: 12,
      selectedItem: null,
      submiting: false,
    };
  },
  mounted() {
    this.center = {
      lat: this.originLat,
      lng: this.originLng,
    };
    console.log(this.trip);
    this.route_id = this.trip.route.id;
    this.fetchStops();
  },
  methods: {
    changeMins(t, c)
    {
      t.setMinutes(t.getMinutes() + c);
    },
    adjustTimeFormat(t)
    {
      const hours = String(t.getHours()).padStart(2, '0');
      const minutes = String(t.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    openTimePicker(index) {
      // Set tempTime to current time value when opening picker
      this.$set(this.tempTime, index, this.time[index]);
    },
    saveTimeChange(index) {
      // Apply the temp time to the actual time
      const newTime = this.tempTime[index];
      
      // Validate: Check if new time is not earlier than previous stop
      if (index > 0) {
        const prevTime = this.parseTime(this.time[index - 1]);
        const currentTime = this.parseTime(newTime);
        
        // Calculate difference (handle midnight crossover)
        let diffMinutes = Math.round((currentTime - prevTime) / 60000);
        
        // If negative and large (like -1380 minutes = -23 hours), it might be a midnight crossover
        // Add 24 hours (1440 minutes) to handle overnight trips
        if (diffMinutes < 0) {
          diffMinutes += 1440; // Add 24 hours in minutes
        }
        
        // If still negative or zero after adjustment, show error
        if (diffMinutes <= 0) {
          this.$notify({
            title: "Invalid Time",
            text: "Arrival time must be after the previous stop's arrival time.",
            type: "error",
          });
          // Close modal without applying changes
          this.$set(this.timeModals, index, false);
          return;
        }
      }
      
      // Close the modal
      this.$set(this.timeModals, index, false);
      
      // Trigger the time change logic with the new time
      this.onTimeChange(index, newTime);
    },
    cancelTimeChange(index) {
      // Just close the modal without applying changes
      this.$set(this.timeModals, index, false);
    },
    onTimeChange(index, newTime) {
      // Update the time array directly
      this.$set(this.time, index, newTime);
      
      // Recalculate inter_time for this stop (if not the first stop)
      if (index > 0) {
        const prevTime = this.parseTime(this.time[index - 1]);
        const currentTime = this.parseTime(newTime);
        
        // Calculate the difference in minutes (handle midnight crossover)
        let diffMinutes = Math.round((currentTime - prevTime) / 60000);
        
        // If negative, assume it's a midnight crossover and add 24 hours
        if (diffMinutes < 0) {
          diffMinutes += 1440; // Add 24 hours in minutes
        }
        
        // Update the inter_time for this stop
        this.$set(this.trip.inter_time, index, diffMinutes);
      }
      
      // Recalculate times for all subsequent stops based on the new time
      this.recalculateTimesFromIndex(index);
    },
    recalculateTimesFromIndex(startIndex) {
      // Start from the next stop after the changed one
      for (let i = startIndex + 1; i < this.time.length; i++) {
        // Get the previous stop's time
        const prevTime = this.parseTime(this.time[i - 1]);
        
        // Add the inter_time for this stop
        // Date object automatically handles midnight crossover
        const newTime = new Date(prevTime);
        newTime.setMinutes(newTime.getMinutes() + this.trip.inter_time[i]);
        
        // Format and update the time (will show 00:15 if it crosses midnight)
        const formattedTime = this.adjustTimeFormat(newTime);
        this.$set(this.time, i, formattedTime);
        
        // Note: inter_time[i] remains unchanged as it represents the interval to THIS stop
        // which should stay consistent when cascading time changes
      }
    },
    AdjustTimeForAllStops(index)
    {
        for (let ii = index; ii < this.time.length; ii++) {
          let stop_time = this.parseTime(this.time[ii-1]);
          this.changeMins(stop_time, this.trip.inter_time[ii])
          let new_time = this.adjustTimeFormat(stop_time)
          this.$set(this.time, ii, new_time);
        }
    },
    finish(event) {
      this.$emit("finish");
    },
    back(event) {
      this.$emit("back");
    },
    addMarker(in_stop = null) {
      this.addStop(in_stop);
    },
    addStop(in_stop, stop_name) {
      let stop =
        in_stop != null
          ? in_stop
          : this.getStopFromPlace(this.currentPlace, stop_name);
      if (stop) {
        const position = {
          lat: parseFloat(stop.lat),
          lng: parseFloat(stop.lng),
        };
        this.markers.push({
          place_id: stop.place_id,
          position: position,
          infoText: "<div class='active-stop'><strong>" + stop.name + "</strong><br/>" + stop.address + "</div>",
        });
        if (in_stop == null) {
          this.stops.push(stop);
        }

        //this.center = marker;
        this.currentPlace = null;
        if (this.$refs.gmapAutocomplete != null) {
          this.$refs.gmapAutocomplete.$el.value = "";
          this.$nextTick(() => {
            this.$refs.gmapAutocomplete.$el.focus();
          });
        }
      }
    },
    getStopFromPlace(place, stop_name) {
      let stop = {
        name: stop_name,
        place_id: place.place_id,
        address: place.formatted_address,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        order: this.stops.length + 1,
        fixed: false,
      };
      return stop;
    },
    parseTime(t) {
      // Handle formats: "HH:MM", "HH:MM:SS", "H:M"
      var d = new Date();
      d.setSeconds(0);
      d.setMilliseconds(0);
      
      // Match time format with optional seconds
      var time = t.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
      
      if (time) {
        d.setHours(parseInt(time[1]));
        d.setMinutes(parseInt(time[2]));
      }
      
      return d;
    },
    randomColor() {
      return this.colors[Math.floor(Math.random() * this.colors.length)];
    },
    setup_polyline() {
      this.polyline=[];
      for (let i = 0; i < this.directions.length; i++) {
        for (let j = 0; j < this.directions[i].length; j++) {
          const direction = this.directions[i][j];
          if (direction.current === 1) {
            this.polyline.push({
              data: direction.overview_path,
              strokeColor: this.randomColor(),
            });
          }
        }
      }
    },
    //API Calls
    fetchStops() {
      let first_stop_time = this.parseTime(this.trip.first_stop_time);

      this.submiting = true;
      axios
        .get(`/routes/${this.route_id}`)
        .then((response) => {
          this.submiting = false;
          let fetchedStops = response.data.stops;
          this.directions = response.data.directions;
          fetchedStops.forEach((stop, index) => {
            stop.order = index + 1;
            stop.lat = parseFloat(stop.lat);
            stop.lng = parseFloat(stop.lng);
          });
          this.stops = fetchedStops;
          let duplicate = false;
          // if(this.trip.trip_details != null)
          // {
          //   let identical = true;
          //   for (let s = 0; s < this.stops.length; s++) {
          //     const stop = this.stops[s];
          //     if(stop.id != this.trip.trip_details[s].stop.id)
          //     {
          //       identical = false;
          //       break;
          //     }
          //   }
          //   duplicate = identical;
          // }
          // Initialize timeModals, originalTime, and tempTime arrays
          this.timeModals = new Array(this.stops.length).fill(false);
          this.originalTime = new Array(this.stops.length).fill(null);
          this.tempTime = new Array(this.stops.length).fill(null);
          
          for (let index = 0; index < this.stops.length; index++) {
            if (index == 0) {
              this.trip.inter_time = [];
              this.time = [];
              let f_stop_time = this.parseTime(this.trip.first_stop_time);
              this.trip.first_stop_time = this.adjustTimeFormat(f_stop_time)
              if(!duplicate)
              {
                this.trip.inter_time.push(0);
                this.time.push(this.trip.first_stop_time);
              }
              else
              {
                this.time.push(this.trip.trip_details[index].planned_timestamp);
                this.trip.inter_time.push(this.trip.trip_details[index].inter_time);
              }
            } else {
              if(!duplicate)
              {
                if(this.trip.trip_details != null && this.trip.trip_details[index] != null && this.trip.trip_details[index].planned_timestamp != null)
                {
                    this.trip.inter_time.push(this.trip.trip_details[index].inter_time);
                    this.time.push(this.trip.trip_details[index].planned_timestamp);
                }
                else{
                    this.trip.inter_time.push(parseInt(this.trip.stop_to_stop_avg_time));
                    first_stop_time.setMinutes(
                    first_stop_time.getMinutes() +
                        parseInt(this.trip.stop_to_stop_avg_time)
                    ); // timestamp
                    first_stop_time = new Date(first_stop_time); // Date object
                    this.time.push(
                    first_stop_time.getHours() + ":" + first_stop_time.getMinutes()
                    );
                }
              }
              else
              {
                this.time.push(this.trip.trip_details[index].planned_timestamp);
                this.trip.inter_time.push(this.trip.trip_details[index].inter_time);
              }
            }
            this.addMarker(this.stops[index]);
          }
          this.setup_polyline();
          console.log(this.stops);
        })
        .catch((error) => {
          this.submiting = false;
          this.$notify({
            title: "Error",
            text: "Error fetching stops of this route",
            type: "error",
          });
          console.log(error);
          this.$router.go(-1);
          //this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

<style>

.list-group-item {
  cursor: pointer;
}

.list-group-item i {
  cursor: pointer;
}

.gm-style .gm-style-iw-d {
  color: #0d508b !important;
}

</style>

<style lang="scss">
.active-stop {
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
